import { GlassCard } from '../../components/Layout/GlassCard'
import { Body, Button, Spacer } from '@spritz-finance/ui'
import { useCreateSpritzCardMutation } from '../../graphql/generated/graphql'
import React from 'react'
import { Column } from '../../components/Layout/Column'

import { useNavigate } from 'react-router-dom'
import { useSpritzCardInfoDialog } from './SpritzCardInfoDialog'
import { CardIntroSpacer, Link, SpritzCardInfoGif, SpritzCardLogo } from './components'
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage'

export const SpritzCardVerify = () => {
    const navigate = useNavigate()

    return (
        <CardIntroSpacer>
            <GlassCard>
                <Column align="center">
                    <SpritzCardLogo />

                    <Body.Bold size={22}>Set up SpritzCard</Body.Bold>
                    <Spacer height={8} />
                    <Body.Med size={16}>
                        Use your on-chain earnings in the real world with a crypto-backed virtual
                        card! To get started, complete a quick identity verification by clicking the
                        button below.
                    </Body.Med>
                    <Spacer height={32} />
                    <Button.CTA variant="gradient" onClick={() => navigate('/verification')}>
                        Let's go!
                    </Button.CTA>
                </Column>
            </GlassCard>
        </CardIntroSpacer>
    )
}

export const SpritzCardSetup = () => {
    const [createCard, { loading, error }] = useCreateSpritzCardMutation({
        refetchQueries: ['SpritzCard'],
    })

    const { openDialog } = useSpritzCardInfoDialog()

    return (
        <CardIntroSpacer>
            <GlassCard>
                <Column align="center">
                    <SpritzCardInfoGif />
                    <Spacer height={16} />
                    <Body.Bold size={22}>Set up SpritzCard</Body.Bold>
                    <Spacer height={8} />
                    <Body.Med size={16}>
                        From URL to IRL, your SpritzCard lets you pay for anything with crypto.
                        &nbsp;
                        <Link onClick={openDialog}>Learn more</Link>
                    </Body.Med>
                    <Spacer height={32} />
                    <Button.CTA variant="gradient" onClick={() => createCard()} loading={loading}>
                        Set up SpritzCard
                    </Button.CTA>

                    {error && (
                        <>
                            <Spacer height={16} />
                            <ErrorMessage message="There was an error setting up your card" />
                        </>
                    )}
                </Column>
            </GlassCard>
        </CardIntroSpacer>
    )
}
